import TagCloud from "react-tag-cloud";
import { useSelector } from "react-redux"
import config from "../../../config"
import { useTheme } from "@material-ui/styles"


export default function HomeWordsCloud({wordsWithFilters}) {
  const { theme: { colors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  return (
    <div className={"mainTagCloud"}>
      <div className={"app-outer"}>
        <div className={"app-inner"}>
          <TagCloud className='tag-cloud' style={{padding: 6, fontFamily: 'Roboto'}}>
            {wordsWithFilters.map(w => (
                <div key={w.text} rotate={w.rotate} style={{
                  fontSize: w.fontSize,
                  fontWeight: "bolder",
                  color: isContrast ? colors.colorText : w.color
                }}>{w.text}</div>
            ))}
          </TagCloud>
        </div>
      </div>
    </div>
  )
}
